import styles from "./Markdown.module.css";
import { Box, Code } from "@mantine/core";
import type { ReactNode } from "react";
import type { Components } from "react-markdown";
import ReactMarkdown from "react-markdown";

const markdownComponents = {
  code: ({ children }: { children?: ReactNode }) => <Code>{children}</Code>
};

export default function Markdown({ children, components = {} }: { children: string; components?: Components }) {
  return (
    <Box className={styles.markdown}>
      <ReactMarkdown components={{ ...markdownComponents, ...components }}>{children}</ReactMarkdown>
    </Box>
  );
}
